//MyFunctions.js



import * as THREE from "three";


//-------------------------------------------------------------------------------------------------------
//This function solves the intersection for two lines of type Line3
//-------------------------------------------------------------------------------------------------------
function intersectLineLine(line1, line2) {

	var l1 = new THREE.Line3(line1.start, line1.end);
	var P = l1.start;
	var r = new THREE.Vector3();
	l1.delta(l1.delta(r));
	r.normalize();

	var l2 = new THREE.Line3(line2.start, line2.end);
	var Q = l2.start;
	var s = new THREE.Vector3();
	l2.delta(l2.delta(s));
	s.normalize();

	var PQx = Q.x - P.x;
	var PQy = Q.y - P.y;
	var rx = r.x;
	var ry = r.y;
	var rxt = -ry;
	var ryt = rx;
	var qx = PQx * rx + PQy * ry;
	var qy = PQx * rxt + PQy * ryt;
	var sx = s.x * rx + s.y * ry;
	var sy = s.x * rxt + s.y * ryt;

	if(sy == 0) {
		// console.log("Lines are parallel")
		return null;
	}

	var a = qx - qy * sx / sy;
	var intPtX = P.x + a * rx;
	var intPtY = P.y + a * ry;
	var pt = new THREE.Vector3(intPtX, intPtY , 0);
	// console.log(pt);

	var centerLine1 = new THREE.Vector3();
	line1.at(0.5, centerLine1);
	var newLine1 = new THREE.Line3(centerLine1, pt);

	var centerLine2 = new THREE.Vector3();
	line2.at(0.5, centerLine2);
	var newLine2 = new THREE.Line3(centerLine2, pt);

	var distIPLine1 = newLine1.distance();
	var distIPLine2 = newLine2.distance();

	if((Math.abs(distIPLine1) > Math.abs(l1.distance()/2)) || (Math.abs(distIPLine2) > Math.abs(l2.distance()/2))) {
		// console.log("Intersection not on line");
		return null;
	}
	else {
		// console.log("Intersection and on line");
		return pt;
	}
}



//-------------------------------------------------------------------------------------------------------
//This function intersects one line with an array of lines
//-------------------------------------------------------------------------------------------------------
function intersectLineLines(line, lines) {

	var intersections = [];

	if (intersections != null);

	for (let i = 0; i < lines.length; i++) {
		var intersection = intersectLineLine(line, lines[i]);
		if(intersection != null) {
			intersections.push(intersection);
		}
	}

	return intersections;
}




//-------------------------------------------------------------------------------------------------------
//This function intersects multiple lines with an array of lines
//-------------------------------------------------------------------------------------------------------
function intersectLinesLines(lines1, lines2) {

	var intersections = [];

	for (let i = 0; i < lines1.length; i++) {
		
		for (let j = 0; j < lines2.length; j++) {
			var intersection = intersectLineLine(lines1[i], lines2[j]);
			if(intersection != null) {
				intersections.push(intersection);
			}
		}	
	}

	return intersections;
}




//-------------------------------------------------------------------------------------------------------
//This function gets line segments that are inside a geometry defined by bounding lines
//-------------------------------------------------------------------------------------------------------
function getInnerSegments(line, boundinglines) {

	var lineSegments = [];
	var intersections = intersectLineLines(line, boundinglines);
	// console.log("Intersections");
	// console.log(intersections);

	if(intersections != null) {
		for (let i = 0; i <= intersections.length/2; i=i+2) {
				var segment = new THREE.Line3(intersections[i], intersections[i+1]);
				// console.log("Segment");
				// console.log(segment);
				lineSegments.push(segment);
		}

		return lineSegments;
	}
	else {
		return null;
	}
}

//-------------------------------------------------------------------------------------------------------
//This function returns points from positions
//-------------------------------------------------------------------------------------------------------
function positionsToPoints(positions) {

	var points = [];

	for (let i = 0; i < positions.length; i = i + 3) {
		var point = new THREE.Vector3( positions[i], positions[i + 1], positions[i + 2] );
		points.push(point);
	}

	return points; 
}

//-------------------------------------------------------------------------------------------------------
//This function returns positions from points
//-------------------------------------------------------------------------------------------------------
function pointsToPositions(points) {

	var positions = [];

	for (let i = 0; i < points.length; i++) {
		positions.push(points[i].x, points[i].y, points[i].z)
	}

	positions.push(points[0].x, points[0].y, points[0].z)

	return positions; 
}




//-------------------------------------------------------------------------------------------------------
//This function returns the bounding rectangle for a geometry on the xy-plane
//-------------------------------------------------------------------------------------------------------
function getBoundingRectangle(bufferGeometry) {

	const posAttr = bufferGeometry.attributes.position.array;
	var vertices = [];

	for(let i = 0; i < posAttr.length; i=i+3) {
		var vec = new THREE.Vector3(posAttr[i], posAttr[i+1], posAttr[i+2]);
		vertices.push(vec);
	}


	var ptMinX = vertices.sort(function (x, y) {
		return x.x -y.x;
	})[0]
	var ptMaxX = vertices.sort(function (x, y) {
		return y.x -x.x;
	})[0]
	var ptMinY = vertices.sort(function (x, y) {
		return x.y -y.y;
	})[0]
	var ptMaxY = vertices.sort(function (x, y) {
		return y.y -x.y;
	})[0]

	var line1 = new THREE.Line3(new THREE.Vector3(ptMinX.x, ptMinY.y, 0), new THREE.Vector3(ptMaxX.x, ptMinY.y, 0));
	var line2 = new THREE.Line3(new THREE.Vector3(ptMinX.x, ptMaxY.y, 0), new THREE.Vector3(ptMaxX.x, ptMaxY.y, 0));
	var line3 = new THREE.Line3(new THREE.Vector3(ptMinX.x, ptMinY.y, 0), new THREE.Vector3(ptMinX.x, ptMaxY.y, 0));
	var line4 = new THREE.Line3(new THREE.Vector3(ptMaxX.x, ptMinY.y, 0), new THREE.Vector3(ptMaxX.x, ptMaxY.y, 0));

	var lines = [line1, line2, line3, line4];

	return lines;
}


//--------------------------------------------------------------------------------------------------------
//This function converts a Line3 to a Line to add it to the scene
//-------------------------------------------------------------------------------------------------------
function lineToGeometry(line) {

	var pts = [];
	pts.push(line.start);
	pts.push(line.end);
	var lineMaterial = new THREE.LineBasicMaterial();

	var myGeometry = new THREE.BufferGeometry().setFromPoints( pts );
	// var myLine = new THREE.Line( myGeometry, lineMaterial);

	return myGeometry;
}


//-------------------------------------------------------------------------------------------------------
//This function returns a closed polyline from an array of points
//-------------------------------------------------------------------------------------------------------
function closedPolylineFromExcessPoints(points) {
	var lines = [];

	for (let i = 0; i < points.length - 1; i++) {
		var line = new THREE.Line3(points[i], points[i+1]);
		lines.push(line);
	}

	return lines;
}


//-------------------------------------------------------------------------------------------------------
//This function returns a closed polyline from an array of points
//-------------------------------------------------------------------------------------------------------
function closedPolylineFromPoints(points) {
	var lines = [];

	points.push(points[0]);

	for (let i = 0; i < points.length - 1; i++) {
		var line = new THREE.Line3(points[i], points[i+1]);
		lines.push(line);
	}

	return lines
}



//-------------------------------------------------------------------------------------------------------
//This function returns a sphere mesh for every point position of a points array to add it to the scene
//-------------------------------------------------------------------------------------------------------
function visualizePoints(points) {

	var meshes = []

	for (let i = 0; i < points.length; i++) {
		var geometry = new THREE.SphereGeometry( 0.1, 16, 16 );
		let sphereMaterial = new THREE.MeshBasicMaterial({ color: 0xeb3434, wireframe: false });
		var mesh = new THREE.Mesh( geometry, sphereMaterial );
		mesh.position.set( points[i].x, points[i].y, points[i].z);
		meshes.push(mesh);	
	}

	return meshes;
}



//-------------------------------------------------------------------------------------------------------
//This function splits a line with another line
//-------------------------------------------------------------------------------------------------------
function splitLineByLine(lineToSplit, cuttingLine) {

	var segments = [];

	var intersectionPt = intersectLineLine(lineToSplit, cuttingLine);

	if(intersectionPt != null) {
		// var s1 = new THREE.Line3(lineToSplit.start, intersectionPt);
		// var s2 = new THREE.Line3(intersectionPt, lineToSplit.end);

		segments.push(new THREE.Line3(lineToSplit.start, intersectionPt), new THREE.Line3(intersectionPt, lineToSplit.end));
	}

	return segments;
}



//-------------------------------------------------------------------------------------------------------
//This function splits one line with an array of lines
//-------------------------------------------------------------------------------------------------------
function splitLineByLines(lineToSplit, cuttingLines) {

	var segments = [];

	for (let i = 0; i < cuttingLines.length; i++) {

		var intersections = intersectLineLines(lineToSplit, cuttingLines);

		if(intersections.length != 0) {
			intersections.push(lineToSplit.start);
			intersections.push(lineToSplit.end);

			intersections.sort(function (x, y) {
				return x.x -y.x;
			})

			for (let j = 0; j < intersections.length - 1; j++) {
				var segment = new THREE.Line3(intersections[i], intersections[i+1]);

				segments.push(segment);
			}
		}
		else {
			segments.push(new THREE.Line3(lineToSplit[i].start, lineToSplit[i].end));
		}
	}

	return segments;
}



//-------------------------------------------------------------------------------------------------------
//This function calculates the surface area of one level (minus the core areas)
//-------------------------------------------------------------------------------------------------------
function getSurfaceArea(buildingPts, corePts) {

	//Raw surface area
	var surfaceArea = 0;

	for (let i = 0; i < buildingPts.length - 1; i++) {
		var srfArea = buildingPts[i].x * buildingPts[i+1].y - buildingPts[i].y * buildingPts[i+1].x;
		surfaceArea = surfaceArea + srfArea;
	}

	surfaceArea = Math.abs(surfaceArea)/2;

	//Core area
	var coreArea = 0;

	for (let i = 0; i < corePts.length; i++) {
		var xLength = corePts[i][1].x - corePts[i][0].x;
		var yLength = corePts[i][2].y - corePts[i][1].y;
		var crArea = xLength * yLength;
		coreArea = coreArea + crArea;
	}

	var finalSurfaceArea = surfaceArea - coreArea;

	return finalSurfaceArea;
}



//-------------------------------------------------------------------------------------------------------
//This function calculates the surface area of one level (minus the core areas)
//-------------------------------------------------------------------------------------------------------
function threeDigitNumber(number) {

	var numberDots = number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");	
	
	return numberDots;
}







//-------------------------------------------------------------------------------------------------------
//Export 
//-------------------------------------------------------------------------------------------------------

export { intersectLineLine, getBoundingRectangle, lineToGeometry, intersectLineLines, intersectLinesLines, 
			closedPolylineFromExcessPoints, visualizePoints, getInnerSegments, splitLineByLine, splitLineByLines, 
			getSurfaceArea, positionsToPoints, closedPolylineFromPoints, threeDigitNumber, pointsToPositions }


